
import { MenuNavigationItem } from '../types';

export const MENU_NAVIGATION_LINKS: MenuNavigationItem[] = [
    {
        name: 'Dashboard',
        href: '/',
        current: false,
        children: [
             {
                name: 'Dashboard',
                href: '/',
                current: false,

            },
            {
                name: 'common.label.mapa-tiempo-real',
                href: '/realtime-map',
                current: false,

            },]

    },
    {
        name: 'common.label.gestion-triptango',

        current: false,
        children: [
            {
                name: 'common.label.vehiculos',
                href: '/vehicles',
                current: false,

            },
            {
                name: 'common.label.conductores',
                href: '/drivers',
                current: false,

            },
            {
                name: 'common.label.asignaciones',
                href: '/assignments',
                current: false,

            },
            {
                name: 'common.form-label.devices',
                href: '/devices',
                current: false,

            },


        ]
    },
    {
        name: 'common.form-label.analisis',
        current: false,
        children: [
            {
                name: 'common.label.mapa-gps-dia',
                href: '/day-gps-map',
                current: false,

            },
            {
                name: 'common.label.viajes',
                href: '/trips',
                current: false,

            },
            {
                name: 'common.form-label.estadisticas-mensuales',
                href: '/mileage-control',
                current: false,

            },
            {
                name: 'common.form-label.control-combustible',
                href: '/fuel-consumption',
                current: false,

            },
            {
                name: 'common.form-label.repostajes-detectados',
                href: '/detected-refuelings',
                current: false,

            },
            {
                name: 'common.label.conducion-peligrosa',
                href: '/aggressive-driving-events',
                current: false,

            },



        ]
    },
    {
        name: 'common.label.encargos',
        current: false,
        children: [
            {
                name: 'common.label.encargos',
                href: '/jobs',
                current: false,

            },
            {
                name: 'common.label.transporte',
                href: '/shipments',
                current: false,

            },
            {
                name: 'dashboard.label.optimizacion-encargos',
                href: '/job-optimization',
                current: false,

            },



        ]
    },
        {
        name: 'common.form-label.optimizacion-flota',
        current: false,
        children: [
            {
                name: 'common.label.crear-ruta',
                href: '/create-route',
                current: false
            },
            {
                name: 'common.label.rutas-planificadas',
                href: '/routes',
                current: false
            },
            {
                name: 'common.label.rutas-realizadas',
                href: '/routes-taken',
                current: false
            },
            {
                name: 'common.label.configuracion-rutas',
                href: '/route-configs',
                current: false
            },
            {
                name: 'common.label.areas',
                href: '/areas',
                current: false
            },
            {
                name: 'common.label.customers',
                href: '/customers',
                current: false
            },
            {
                name: 'common.label.actualizar-clientes',
                href: '/update-customers',
                current: false
            },
            {
                name: 'common.label.sale-representatives',
                href: '/sale-representatives',
                current: false
            }



        ]
    },
   {
        name: 'common.label.parametros',
        current: false,
        children: [
            {
                name: 'common.label.centro',
                href: '/centers',
                current: false,

            },
            {
                name: 'common.label.tipos-mantenimiento',
                href: '/maintenance-types',
                current: false,

            },
            {
                name: 'common.label.estados-itv',
                href: '/inspections-statuses',
                current: false,

            },
            {
                name: 'common.label.compania-aseguradora',
                href: '/insurance-company',
                current: false,

            },
            {
                name: 'common.label.tipos-multa',
                href: '/fine-types',
                current: false,

            },
            {
                name: 'common.label.estados-multa',
                href: '/fine-statuses',
                current: false,

            },
            {
                name: 'common.form-label.responsables',
                href: '/responsibles',
                current: false,

            },
            {
                name: 'common.label.marcas',
                href: 'brands',
                current: false,
            },
            {
                name: 'common.label.modelos',
                href: 'models',
                current: false,
            },
            {
                name: 'common.form-label.proveedores-vehicle',
                href: 'providers',
                current: false,
            },
            {
                name: 'common.label.usuarios',
                href: 'users',
                current: false,
            },
        ]
    }, 


];